const initialState = {
  query: "",
};

export default initialState;
